import { Tooltip } from '@mui';
import { withStyles } from 'tss-react/mui';
import { tooltipStyles } from '@constants/mui-theme';

const CustomTooltip = withStyles(Tooltip, () => ({
  tooltip: {
    backgroundColor: tooltipStyles.backgroundColor,
    borderRadius: tooltipStyles.borderRadius,
    color: tooltipStyles.color,
    fontFamily: tooltipStyles.fontFamily,
    fontSize: tooltipStyles.fontSize,
    lineHeight: tooltipStyles.lineHeight,
    padding: tooltipStyles.padding
  }
}));

export default CustomTooltip;
